// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__38vS4","actions":"GroupTable_actions__p7eFg","deleteModalFooter":"GroupTable_deleteModalFooter__2pMjD"};